<template>
  <div :id="id" class="kartica" :class="{ sklopiva, otvoreno: ot }">
    <div class="naslov-kartice" @click="sklopiva && prebaci()">
      {{ naslov }}
      <span v-if="dodatak" class="dodatak">{{ dodatak }}</span>
      <span v-if="kljucevi.length" class="dodatak">{{ popunjeno }} od {{ kljucevi.length }}</span>
      <span v-if="gresaka" class="mali-znak gr">{{ gresaka }} {{ gresaka === 1 ? 'greška' : 'grešaka' }}</span>
      <span v-if="izmjena" class="mali-znak iz">{{ izmjena }} izm.</span>
      <span v-if="sklopiva" class="strelica">▾</span>
    </div>
    <div class="tijelo"><slot></slot></div>
  </div>
</template>

<script>
import { brojPopunjenih } from './formaLogika'

// Kartica s plavim naslovom. sklopiva + :otvoreno.sync="..." za rijetke skupine.
// kljucevi + model daju brojač "N od M popunjeno" i značke grešaka/izmjena u naslovu.
export default {
  name: 'FormaKartica',
  inject: { okvir: { default: null } },
  props: {
    id: { type: String, default: '' },
    naslov: { type: String, default: '' },
    dodatak: { type: String, default: '' },
    sklopiva: { type: Boolean, default: false },
    otvoreno: { type: Boolean, default: true },
    kljucevi: { type: Array, default: () => [] },
    model: { type: Object, default: () => ({}) }
  },
  data () { return { ot: this.otvoreno } },
  computed: {
    popunjeno () { return brojPopunjenih(this.model, this.kljucevi) },
    gresaka () { return this.okvir ? this.kljucevi.filter(k => this.okvir.greske[k]).length : 0 },
    izmjena () { return this.okvir ? this.kljucevi.filter(k => this.okvir.izmijenjena.indexOf(k) >= 0).length : 0 }
  },
  watch: {
    otvoreno (v) { this.ot = v },
    gresaka (n) { if (n > 0) this.otvori() }
  },
  created () { if (this.okvir) this.okvir.registriraj(this) },
  beforeDestroy () { if (this.okvir) this.okvir.odjavi(this) },
  methods: {
    prebaci () { this.postavi(!this.ot) },
    otvori () { this.postavi(true) },
    postavi (v) {
      this.ot = v
      this.$emit('update:otvoreno', v)
    }
  }
}
</script>
